//@import dependencies
import React, {Component} from 'react'
//@end

//@import components
import {ProfileScreenLayout} from 'app_components/screens/profile'
//@end

//@import services
import {routingService} from 'app_services/routingService'
//@end

// @ADD Component types
interface IProfileScreenProps {
  history: any
}
interface IProfileScreenState {}

class ProfileScreen extends Component<IProfileScreenProps, IProfileScreenState> {

  handleGoToPage = () => {
    this.props.history.push(routingService.getSecurePath())
  }

  render() {
    return(
      <ProfileScreenLayout onHandleGoToPage={this.handleGoToPage} />
    )
  }
}

export default ProfileScreen
